export default __webpack_public_path__ + "static/ak-cached/24h/media/bhrxImage.cc672afa.png";